exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bsstoolbar{margin-bottom:20px !important}.bsstoolbarwrapper .k-button{width:30px !important}.k-button.dropdown-toggle{width:45px !important}.dropdown .dropdown-menu{margin-top:6px}span.withstackedicons{margin-top:-5px;margin-left:-5px;font-size:12px}", ""]);

// exports
